/* Font size preference — applies before paint via data-sm-font on <html>.
 * xs = original scarce-mono root (0.8rem). Default attribute is s. */

const STORAGE_KEY = "sm-font";
const COOKIE = "sm_font";
const SIZES = ["xs", "s", "m", "l", "xl"];
const DEFAULT = "s";

function normalize(v) {
    return SIZES.includes(v) ? v : DEFAULT;
}

function readStored() {
    try {
        const ls = window.localStorage.getItem(STORAGE_KEY);
        if (ls) return normalize(ls);
    } catch (_) { /* private mode */ }
    const m = document.cookie.match(/(?:^|; )sm_font=([^;]*)/);
    if (m) return normalize(decodeURIComponent(m[1]));
    return null;
}

function csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta && meta.getAttribute("content");
}

function persistUrl() {
    const el = document.documentElement;
    return el.getAttribute("data-sm-font-persist") || null;
}

function persistToAccount(size) {
    const url = persistUrl();
    if (!url) return;
    const token = csrfToken();
    if (!token) return;
    const body = new URLSearchParams();
    body.set("ui_preferences[font_size]", size);
    fetch(url, {
        method: "PATCH",
        headers: {
            "X-CSRF-Token": token,
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: body.toString(),
        credentials: "same-origin",
    }).catch(() => { /* cookie/localStorage already applied */ });
}

export function applyFontSize(size, { persist = false } = {}) {
    const v = normalize(size);
    document.documentElement.setAttribute("data-sm-font", v);
    try {
        window.localStorage.setItem(STORAGE_KEY, v);
    } catch (_) { /* ignore */ }
    const maxAge = 60 * 60 * 24 * 365;
    document.cookie = `${COOKIE}=${encodeURIComponent(v)}; path=/; max-age=${maxAge}; SameSite=Lax`;
    document.querySelectorAll(".cg-font-size__opt").forEach((el) => {
        const input = el.querySelector("input[data-sm-font]");
        const on = input && input.getAttribute("data-sm-font") === v;
        el.classList.toggle("cg-font-size__opt--on", !!on);
        if (input) input.checked = !!on;
    });
    if (persist) persistToAccount(v);
    return v;
}

export function currentFontSize() {
    return normalize(
        document.documentElement.getAttribute("data-sm-font") || readStored() || DEFAULT
    );
}

function onChange(ev) {
    const input = ev.target.closest && ev.target.closest("input[data-sm-font]");
    if (!input) return;
    // Profile form submits itself; only auto-persist the header quick picker.
    const inForm = input.closest("form[data-sm-font-form]");
    applyFontSize(input.getAttribute("data-sm-font"), { persist: !inForm });
}

export function initFontSize() {
    // Prefer the server-rendered attribute (account or cookie); mirror it
    // into localStorage so other tabs stay aligned. Fall back to storage
    // only when the attribute is missing.
    const fromDom = document.documentElement.getAttribute("data-sm-font");
    if (fromDom && SIZES.includes(fromDom)) {
        applyFontSize(fromDom);
    } else {
        applyFontSize(readStored() || DEFAULT);
    }
    document.addEventListener("change", onChange, false);
}

export default initFontSize;
